<div class="top-header" id="lnr-top-header">
  <div class="header-container" *ngIf="!loading">
    <mat-icon class="icon" *ngIf="!business?.imgSource">account_circle</mat-icon>

    <img id="image-file-input"
    class="image"
    *ngIf="business?.imgSource"
    [src]="business?.imgSource"
    alt="{{ labels.uploadedImgAlt }}">

    <div class="title-info" id="lnr-top-header-title-info">
      <div class="title"
        [matTooltip]="business?.businessName!.length > 20 ? (business?.businessName!) : ''"
        matTooltipClass="name-tooltip">{{business?.businessName}}</div>
      <div class="info">{{business?.country?.name}}</div>
    </div>

    <div class="points-info" *ngIf="businessSummary?.pointsByFamily?.length">
      <div class="points-added" *ngFor="let item of businessSummary?.pointsByFamily | slice:0:3">
        <div class="points">{{ item.pointSummary?.totalPoints || 0 }}<mat-icon class="icon">stars</mat-icon></div>
        <div class="label">{{ labels.totalPointsFor }} {{ item.family?.name }} {{ labels.series }}</div>
      </div>
      <div
        class="points-added show-more-btn"
        *ngIf="businessSummary!.pointsByFamily.length > 3"
        (click)="navigateToPointsDetail()"
      >
        <div class="points">
          <mat-icon>add</mat-icon>
        </div>
        <div class="label">{{ labels.showMore }}</div>
      </div>
    </div>

    <div class="user-info" [matMenuTriggerFor]="userMenu.menu">
      <div class="user-name"
        [matTooltip]="(representative?.firstName!.length > 20 || representative?.lastName!.length > 20) ? (representative?.firstName + ' ' + representative?.lastName) : ''"
        matTooltipClass="name-tooltip">{{ representative?.firstName }} {{ representative?.lastName }}</div>
      <mat-icon id="lnr-user-header-photo-area-more" class="menu-icon menu-icon-expand">expand_more</mat-icon>
      <mat-icon *ngIf="!representative?.picture">account_circle</mat-icon>
      <img id="image-file-input"
      class="image"
      *ngIf="representative?.picture"
      [src]="representative?.picture"
      alt="{{ labels.uploadedImgAlt }}">
      <app-profile-menu #userMenu [profileMenuItems]="profileMenuItems"></app-profile-menu>
    </div>
  </div>

  <mat-spinner
    *ngIf="loading"
    class="loading"
    diameter="50"
  ></mat-spinner>
</div>
